import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToLocal'
})
export class UtcToLocalPipe implements PipeTransform {
  transform(value: string, format: 'long' | 'short' = 'long'): string {
    if (!value) return '';

    const utcDate = new Date(value + ' UTC');

    if (format === 'short') {
      return this.formatShortDate(utcDate);
    } else {
      return this.formatLongDate(utcDate);
    }
  }

  private formatLongDate(date: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    };
    return date.toLocaleString('en-US', options);
  }

  private formatShortDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const amPm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12;

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${amPm}`;
  }
}
